import './ProductHero.css'

type ProductHeroProps = {
  imageSrc: string
}

export default function ProductHero({ imageSrc }: ProductHeroProps) {
  return (
    <section className="product-hero relative min-h-[410px] overflow-hidden text-white min-[900px]:min-h-[325px]">
      <img src={imageSrc} alt="Modern Caribbean home project" className="absolute bottom-0 left-[40%] right-0 top-0 hidden h-full w-[60%] object-cover object-right min-[900px]:block" />
      <div className="product-hero__copy relative z-10 flex items-center px-8 py-12 min-[900px]:h-[325px] min-[900px]:w-[46%] min-[900px]:py-8 min-[900px]:pl-[13%] min-[900px]:pr-[4%] min-[900px]:[clip-path:polygon(0_0,100%_0,82%_100%,0_100%)]">
        <div className="max-w-[450px]">
          <h1 className="product-hero__title">
            Engineered.<br />Built.<br /><span className="text-[#c14a38]">To Protect.</span>
          </h1>
          <p className="product-hero__description mt-4 max-w-[365px] min-[900px]:mt-3">High-performance roofing and building solutions designed for the Caribbean.</p>
        </div>
      </div>
      <div className="relative min-h-[230px] min-[900px]:hidden">
        <img src={imageSrc} alt="Modern Caribbean home project" className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <div aria-hidden="true" className="product-hero__corner product-hero__corner--light absolute bottom-[-30px] right-[-10px] z-20 h-24 w-24 rotate-45 border-4" />
      <div aria-hidden="true" className="product-hero__corner product-hero__corner--red absolute bottom-[-30px] right-[-2px] z-20 h-20 w-20 rotate-45 border-4" />
    </section>
  )
}
